<div class="content">
  <rd-shared-icon
    class="icon-unavailable"
    aria-hidden="true"
    [iconSymbol]="'icon-file-circle-info'"
    [iconTheme]="'primary'"></rd-shared-icon>
  <h1 class="gift-card-unavailable-header">
    {{ 'gift_card.unavailable.header' | translate }}
  </h1>
  <p
    class="gift-card-unavailable-description rd-shared-link"
    [innerHTML]="'gift_card.unavailable.description' | translate"></p>
  <rd-shared-button
    class="go-back-button"
    [buttonTheme]="'primary'"
    [buttonText]="'gift_card.unavailable.go_back' | translate"
    [redirectURL]="'/'"></rd-shared-button>
</div>
